export { getFullProgramContentsData } from './getFullProgramContentsData'
export type { TResPrograms, ContentPartType, ContentSubPartType } from './types'
